// Google My Business Attributes - Common business attributes organized by category

export const GMB_ATTRIBUTES = {
  'Payment Methods': [
    'Accepts Credit Cards',
    'Accepts Debit Cards',
    'Cash Only',
    'Contactless Payment',
    'Mobile Payments',
    'Checks Accepted',
    'Apple Pay',
    'Google Pay',
    'Cryptocurrency'
  ],
  
  'Accessibility': [
    'Wheelchair Accessible',
    'Accessible Entrance',
    'Accessible Restroom',
    'Accessible Parking',
    'Braille Menu',
    'Hearing Loop',
    'Wheelchair Accessible Elevator',
    'Accessible Seating'
  ],
  
  'Amenities': [
    'Free Wi-Fi',
    'Parking Available',
    'Valet Parking',
    'Street Parking',
    'Free Parking',
    'Paid Parking',
    'Air Conditioning',
    'Heating',
    'Outdoor Seating',
    'Indoor Seating',
    'Restroom',
    'Gender-Neutral Restroom',
    'Changing Table',
    'High Chairs',
    'Kids Menu'
  ],
  
  'Services': [
    'Delivery Available',
    'Takeout Available',
    'Dine-in Available',
    'Reservations Accepted',
    'Walk-ins Welcome',
    'Appointment Required',
    'Online Booking',
    'Curbside Pickup',
    'Drive-through',
    'In-store Shopping',
    'In-store Pickup',
    'Same-day Delivery',
    'Gift Wrapping',
    'Gift Cards Available',
    'Loyalty Program',
    'Rewards Program'
  ],
  
  'Policies': [
    'Pet Friendly',
    'Dogs Allowed',
    'Cats Allowed',
    'Family Friendly',
    'LGBTQ+ Friendly',
    'Smoking Allowed',
    'No Smoking',
    'Outdoor Smoking Area',
    'Age Restrictions',
    'Adults Only',
    'All Ages Welcome'
  ],
  
  'Atmosphere': [
    'Casual',
    'Upscale',
    'Romantic',
    'Intimate',
    'Trendy',
    'Historic',
    'Modern',
    'Traditional',
    'Cozy',
    'Lively',
    'Quiet',
    'Loud',
    'Good for Groups',
    'Good for Kids',
    'Good for Dates',
    'Good for Business Meetings'
  ],
  
  'Dining Options': [
    'Breakfast',
    'Brunch',
    'Lunch',
    'Dinner',
    'Late Night Dining',
    'All You Can Eat',
    'Buffet',
    'Catering',
    'Private Dining',
    'Bar on Site',
    'Full Bar',
    'Wine Bar',
    'Beer Available',
    'Happy Hour',
    'Live Music',
    'Live Sports',
    'Karaoke'
  ],
  
  'Dietary Options': [
    'Vegetarian Options',
    'Vegan Options',
    'Gluten-Free Options',
    'Dairy-Free Options',
    'Nut-Free Options',
    'Halal Food',
    'Kosher Food',
    'Organic Food',
    'Locally Sourced',
    'Farm to Table'
  ],
  
  'Safety & Cleanliness': [
    'Staff Wears Masks',
    'Staff Gets Temperature Checks',
    'Masks Required',
    'Reservations Required',
    'Safety Dividers',
    'Hand Sanitizer Available',
    'Sanitizing Between Customers',
    'Contactless Payments Only',
    'Digital Receipts'
  ],
  
  'Technology': [
    'Free Wi-Fi',
    'TV Available',
    'Projector Available',
    'Sound System',
    'Charging Stations',
    'Online Ordering',
    'Mobile App',
    'Digital Menu',
    'QR Code Menu'
  ],
  
  'Parking & Transportation': [
    'Free Parking',
    'Paid Parking',
    'Street Parking',
    'Valet Parking',
    'Garage Parking',
    'Bicycle Parking',
    'EV Charging Station',
    'Near Public Transit',
    'Taxi Stand',
    'Shuttle Service'
  ]
};

// Flatten all attributes into a single sorted array
export const ALL_GMB_ATTRIBUTES = Object.values(GMB_ATTRIBUTES)
  .flat()
  .sort();

export default GMB_ATTRIBUTES;




